<ziro-self-serve-top-bar></ziro-self-serve-top-bar>

<ziro-loading-block [hidden]="!isLoading && (isFetching360View$ | async) === false"></ziro-loading-block>

@if (!isLoading && (isFetching360View$ | async) === false) {
  <div data-automation="self-serve-user-details">
    @if (!anyEndUserHasConfigurableServices()) {
      <div id="self-serve-no-services" class="alert alert-warning text-center">
        {{ 'tkey;selfserve.user.nophoneservices.helpblock' | translate }}
      </div>
    }
    <div class="row self-serve-user-details-services" data-automation="self-serve-user-details-services">
      <!-- VM -->
      @for (voicemail of voicemails; track voicemail; let i = $index) {
        <ziro-self-serve-card
          [routerLink]="'/self-serve/user/' + user.ref.username + '/voicemail-pin-reset/' + voicemail.id"
          [dataAutomation]="'self-serve-voicemail-pin-reset-' + i"
          [header]="'tkey;self_serve.voicemail.header'"
          [description]="'tkey;self_serve.voicemail.description'"
          [displayBadgePrimary]="true"
          [lottieFile]="vmJson"
          class="col-lg-6"
        >
          <span badgePrimary>
            {{ 'tkey;self_serve.voicemail.badge' | translate }} {{ voicemail.extension | telephoneNumberFilter }}
          </span>
        </ziro-self-serve-card>
      }
      <!-- Extension Mobility -->
      @for (extensionMobility of extensionMobilities; track extensionMobility; let i = $index) {
        <ziro-self-serve-card
          [routerLink]="
            '/self-serve/user/' + user.ref.username + '/extension-mobility-pin-reset/' + extensionMobility.id
          "
          [dataAutomation]="'self-serve-extension-mobility-pin-reset-' + i"
          [header]="'tkey;self_serve.ext_mobility.header'"
          [description]="'tkey;self_serve.ext_mobility.description'"
          [lottieFile]="extMobilityJson"
          class="col-lg-6"
        ></ziro-self-serve-card>
      }
      <!-- SNR - Edit -->
      @for (snrDestination of snrDestinations; track snrDestination; let i = $index) {
        <ziro-self-serve-card
          [routerLink]="'/self-serve/user/' + user.ref.username + '/snr-destination/' + snrDestination.id"
          [dataAutomation]="'self-serve-snr-pin-reset-' + i"
          [header]="'tkey;self_serve.snr.header'"
          [description]="'tkey;self_serve.snr.description'"
          [displayBadgePrimary]="!!snrDestination.destinationNumber"
          [displayBadgeSecondary]="!snrDestination.destinationNumber"
          [lottieFile]="snrJson"
          class="col-lg-6"
        >
          <span badgePrimary>
            {{ 'tkey;self_serve.snr.badge.active' | translate }}
            {{ snrDestination.destinationNumber | telephoneNumberFilter }}
          </span>
          <span badgeSecondary>
            {{ 'tkey;self_serve.snr.badge.no_destination' | translate }}
          </span>
        </ziro-self-serve-card>
      }
      <!-- SNR - Create -->
      @for (snrProfiles of snrProfiles; track snrProfiles; let i = $index) {
        <ziro-self-serve-card
          [routerLink]="'/self-serve/user/' + user.ref.username + '/snr-profile/' + snrProfiles.id + '/snr-destination'"
          [dataAutomation]="'self-serve-snr-pin-reset-' + i"
          [header]="'tkey;self_serve.snr.header'"
          [description]="'tkey;self_serve.snr.description'"
          [displayBadgeSecondary]="true"
          [lottieFile]="snrJson"
          class="col-lg-6"
        >
          <span badgeSecondary>
            {{ 'tkey;self_serve.snr.badge.no_destination' | translate }}
          </span>
        </ziro-self-serve-card>
      }
      <!-- Call Forward -->
      @for (dnContainer of callForwards; track dnContainer; let i = $index) {
        <ziro-self-serve-card
          [routerLink]="'/self-serve/user/' + user.ref.username + '/call-forward/' + dnContainer.directoryNumberRef.id"
          [dataAutomation]="'self-serve-call-forward-pin-reset-' + i"
          [header]="'tkey;self_serve.call_forward.header'"
          [description]="'tkey;self_serve.call_forward.description'"
          [displayBadgePrimary]="!!dnContainer.directoryNumber.forwardAll.destination"
          [displayBadgeSecondary]="!dnContainer.directoryNumber.forwardAll.destination"
          [lottieFile]="callForwardJson"
          class="col-lg-6"
        >
          <span badgePrimary>
            {{ 'tkey;self_serve.call_forward.badge.destination' | translate }}
            {{ dnContainer.directoryNumber.forwardAll.destination | telephoneNumberFilter }}
          </span>
          <span badgeSecondary>
            {{ 'tkey;self_serve.call_forward.badge.no_destination' | translate }}
          </span>
        </ziro-self-serve-card>
      }
      <!-- Edit Deskphone Buttons -->
      @for (phoneContainer of editDeskphones; track phoneContainer; let i = $index) {
        <ziro-self-serve-card
          [routerLink]="'/self-serve/user/' + user.ref.username + '/phone/' + phoneContainer.phoneRef.id"
          [dataAutomation]="'self-serve-deskphone-edit-' + i"
          [header]="'tkey;self_serve.phone.buttons.header'"
          [description]="'tkey;self_serve.phone.buttons.description'"
          [displayBadgePrimary]="!!phoneContainer.phoneRef.description"
          [displayBadgeSecondary]="
            (phoneContainer.statusAsync | async)?.status === 'NOT_FOUND' ||
            (phoneContainer.statusAsync | async)?.status === 'UNREGISTERED'
          "
          [badgeSecondaryCssClass]="'bg-warning animate__animated animate__fadeIn'"
          [lottieFile]="editDeskphoneJson"
          class="col-lg-6"
        >
          <span badgePrimary>
            {{ phoneContainer.phoneRef.description }}
          </span>
          <span badgeSecondary>
            <div class="d-inline-flex align-items-center">
              <strong class="p-0 m-0">
                <i class="fa fa-warning me-1"></i>
                <span>{{ 'tkey;selfserve.user.deskphone.out_of_service.title' | translate }}</span>
              </strong>
            </div>
          </span>
        </ziro-self-serve-card>
      }
      <!-- Replace Existing Deskphone -->
      @for (phoneContainer of replaceDeskphones; track phoneContainer; let i = $index) {
        <ziro-self-serve-card
          [routerLink]="'/self-serve/user/' + user.ref.username + '/replace-deskphone/' + phoneContainer.phoneRef.id"
          [dataAutomation]="'self-serve-replace-deskphone-' + i"
          [header]="'tkey;self_serve.phone.replace.header'"
          [description]="'tkey;self_serve.phone.replace.description'"
          [displayBadgePrimary]="!!phoneContainer.phoneRef.description"
          [lottieFile]="replaceDeskphoneJson"
          class="col-lg-6"
        >
          <span badgePrimary>
            {{ phoneContainer.phoneRef.description }}
          </span>
        </ziro-self-serve-card>
      }
      <!-- Activate Deskphone -->
      @if (selfServe360View.canActivateDeskphone) {
        <ziro-self-serve-card
          [routerLink]="'/self-serve/user/' + user.ref.username + '/activate'"
          [dataAutomation]="'activate-deskphone-button'"
          [header]="'tkey;self_serve.phone.activate.header'"
          [description]="'tkey;self_serve.phone.activate.description'"
          [lottieFile]="activateDeskphoneJson"
          class="col-lg-6"
        ></ziro-self-serve-card>
      }
      <ziro-footer class="col-12 mt-4 mb-3" [cssClasses]="'text-center'"></ziro-footer>
    </div>
  </div>
}
